export default __webpack_public_path__ + "static/media/TETHYS.4a4d2d5c.svg";